module.exports = __webpack_public_path__ + "static/media/view-off-fill.56d70187.svg";